import { useTenantMetadataStore } from "../store/useTenantMetadataStore";

export type TenantImage = {
  url: string;
  description?: string;
};

export const useTenantImages = () => {
  const theme = useTenantMetadataStore();
  const base = theme.metadata.imageBasePath;

  const image = (filename: string, description?: string): TenantImage => ({
    url: `${base}${filename}`,
    description,
  });

  const resolveHashSubstring = (hash: string) => {
    if (!hash || hash === "") return "";
    return `-${hash}`;
  }

  return {
    heroImg: image(`hero${resolveHashSubstring(theme.ImageHashes.heroImg)}.avif`, `Landing de ${theme.metadata.name}`),
    aboutImg: image(`about${resolveHashSubstring(theme.ImageHashes.aboutImg)}.avif`, `About de ${theme.metadata.name}`),
    blogImg: image(`blog${resolveHashSubstring(theme.ImageHashes.blogImg)}.png`, "Visita nuestro Blog"),
    checkoutImg: image(`checkout${resolveHashSubstring(theme.ImageHashes.checkoutImg)}.png`, `Checkout de ${theme.metadata.name}`),
    emptyListImg: image(`empty-list${resolveHashSubstring(theme.ImageHashes.emptyListImg)}.avif`, `La lista está vacía`),
    eventsImg: image(`events${resolveHashSubstring(theme.ImageHashes.eventsImg)}.png`, `Eventos especiales`),
    faviconImg: image(`favicon${resolveHashSubstring(theme.ImageHashes.faviconImg)}.png`, `Website icon backup de ${theme.metadata.name}`),
    customerHomeImg: image(`customer-home${resolveHashSubstring(theme.ImageHashes.customerHomeImg)}.png`, `Mi Cuenta`),
    addressesImg: image(`addresses${resolveHashSubstring(theme.ImageHashes.addressesImg)}.png`, `Direcciones`),
    editUserImg: image(`edit-user${resolveHashSubstring(theme.ImageHashes.editUserImg)}.png`, `Editar usuario`),
    myOrdersImg: image(`my-orders${resolveHashSubstring(theme.ImageHashes.myOrdersImg)}.png`, `Mis órdenes`),
    forgotPassImg: image(`forgot-pass${resolveHashSubstring(theme.ImageHashes.forgotPassImg)}.png`, `Olvidaste tu contraseña?`),
    logoExpressLargeImg: image(`logo-express-large${resolveHashSubstring(theme.ImageHashes.logoExpressLargeImg)}.png`, `Logo express grande de ${theme.metadata.name}`),
    logoExpressJpegImg: image(`logo-express${resolveHashSubstring(theme.ImageHashes.logoExpressJpegImg)}.avif`, `Logo express de ${theme.metadata.name}`),
    logoExpressPngImg: image(`logo-express${resolveHashSubstring(theme.ImageHashes.logoExpressPngImg)}.png`, `Logo express de ${theme.metadata.name}`),
    logoFlatPngImg: image(`logo-tm-flat${resolveHashSubstring(theme.ImageHashes.logoFlatPngImg)}.png`, `Logo flat de ${theme.metadata.name}`),
    logoJpegImg: image(`logo-tm${resolveHashSubstring(theme.ImageHashes.logoJpegImg)}.avif`, `Logo de ${theme.metadata.name}`),
    logoPngImg: image(`logo-tm${resolveHashSubstring(theme.ImageHashes.logoPngImg)}.png`, `Logo de ${theme.metadata.name}`),
    notFoundImg: image(`not-found${resolveHashSubstring(theme.ImageHashes.notFoundImg)}.avif`, `Página no encontrada (404)`),
    securityImg: image(`security${resolveHashSubstring(theme.ImageHashes.securityImg)}.png`, `Autenticación`),
    servicesImg: image(`services${resolveHashSubstring(theme.ImageHashes.servicesImg)}.png`, `Servicios de ${theme.metadata.name}`),
    privacyPolicyImg: image(`privacy${resolveHashSubstring(theme.ImageHashes.privacyPolicyImg)}.png`, `Politica de Privacidad de ${theme.metadata.name}`),
    unauthorizedImg: image(`unauthorized${resolveHashSubstring(theme.ImageHashes.unauthorizedImg)}.avif`, `No Autorizado`),
  };
};
